import { MaintenanceForwardingEstablishmentChoiceEntryKlass } from "../../../../../features/forwardings/types/forwardings/establishmentChoiceEntries/establishmentChoiceEntry.type";
import { useForwardingTabContext } from "../../../../../hooks/forwardings/useForwardingTabContext";
import MaintenanceWorkflowForwardingEstablishmentChoiceEntrySectionAuctionEntry, { MaintenanceWorkflowForwardingEstablishmentChoiceEntrySectionAuctionEntryProps } from "./Entries/AuctionEntry";
import MaintenanceWorkflowForwardingEstablishmentChoiceEntrySectionManualEntry, { MaintenanceWorkflowForwardingEstablishmentChoiceEntrySectionManualEntryProps } from "./Entries/ManualEntry";

interface MaintenanceWorkflowForwardingEstablishmentChoiceEntrySectionProps {
  manualEntryProps?: MaintenanceWorkflowForwardingEstablishmentChoiceEntrySectionManualEntryProps;
  auctionEntryProps?: MaintenanceWorkflowForwardingEstablishmentChoiceEntrySectionAuctionEntryProps;
}

const MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection = ({
  manualEntryProps,
  auctionEntryProps,
}: MaintenanceWorkflowForwardingEstablishmentChoiceEntrySectionProps) => {
  const { forwarding } = useForwardingTabContext();

  if (forwarding.establishment_choice_entry_type === MaintenanceForwardingEstablishmentChoiceEntryKlass.ManualEntry) {
    return (
      <MaintenanceWorkflowForwardingEstablishmentChoiceEntrySectionManualEntry {...manualEntryProps} />
    );
  }

  if (forwarding.establishment_choice_entry_type === MaintenanceForwardingEstablishmentChoiceEntryKlass.AuctionEntry) {
    return (
      <MaintenanceWorkflowForwardingEstablishmentChoiceEntrySectionAuctionEntry {...auctionEntryProps} />
    );
  }

  return null;
}

export default MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection;
